import { ref } from "vue";

import { type types, useClient } from "@/lib/openapi";
import { startStekLiveMgtGetMetricsStartPost } from "@/lib/openapi/gen/sdk.gen";
import { useReleaseStore } from "@/stores/release-store";

export function useLiveMetricsManager() {
    const loading = ref(false);
    const releaseStore = useReleaseStore();
    const client = useClient({
        requires: {
            auth: true,
            organization: true,
            stek: true,
        },
    });

    async function fetchMetrics(
        entityId: string,
        entityType: string,
        hours: number,
        stekRelease?: string | null
    ): Promise<types.LiveMetrics> {
        loading.value = true;
        try {
            // Build the request body based on entity type
            const body: {
                stek_id?: string;
                domain_id?: string;
                product_id?: string;
                process_id?: string;
                hours: number;
                stek_release?: string;
            } = { hours };

            const release =
                stekRelease === undefined
                    ? releaseStore.activeRelease
                    : stekRelease;
            if (release) {
                body.stek_release = release;
            }

            switch (entityType) {
                case "stek": {
                    body.stek_id = entityId;
                    break;
                }
                case "domain": {
                    body.domain_id = entityId;
                    break;
                }
                case "product": {
                    body.product_id = entityId;
                    break;
                }
                case "process": {
                    body.process_id = entityId;
                    break;
                }
                default:
                    throw new Error(`Unknown entity type: ${entityType}`);
            }

            const { data } = await startStekLiveMgtGetMetricsStartPost<true>({
                client,
                throwOnError: true,
                body,
            });
            return data;
        } finally {
            loading.value = false;
        }
    }

    return {
        fetchMetrics,
        loading,
    };
}
